/**
 * 初始化全局埋点
 */
import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { APP_ID, APP_NAME } from '@whelk/const/src/appInfo';
import { RootState } from '@whelk/store';
import { trackLogin, trackOrigin, trackSCGlobalProperty } from '@whelk/utils/src/track';

const useInitGlobalTrack = () => {
  const isLogin = useSelector((state: RootState) => state.user.isLogin);
  const userID = useSelector((state: RootState) => state.user.userID);
  const realUserID = useSelector((state: RootState) => state.user.realUserID);

  useEffect(() => {
    if (realUserID) {
      trackSCGlobalProperty({
        hailuo_user_id: realUserID,
      });
    }
  }, [realUserID]);

  useEffect(() => {
    trackSCGlobalProperty({
      login_status: isLogin ? 2 : 1, // 1：未登录  2：登录
    });
    if (isLogin) {
      trackLogin(userID);
    }
  }, [isLogin, userID]);

  useEffect(() => {
    // 注册神策公共属性
    trackSCGlobalProperty({
      device: trackOrigin,
      app_id: APP_ID,
      app_name: APP_NAME,
    });
  }, []);
};

export default useInitGlobalTrack;
